import { FC, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import type { AppDispatch } from "store";
import Modal from "./Modal";
import { TrashIcon } from "shared/ui";
import { selectDrawingCount, clearDrawingTools } from "features/drawing-tool/model";
import { selectIndicatorsCount, clearIndicators } from "features/indicators/model";
import styles from "./ClearAllButton.module.css";

export const ClearAllButton: FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const drawingCount = useSelector(selectDrawingCount);
  const indicatorsCount = useSelector(selectIndicatorsCount);
  const total = drawingCount + indicatorsCount;

  const [open, setOpen] = useState(false);

  if (total === 0) return null;

  const handleConfirm = () => {
    dispatch(clearDrawingTools());
    dispatch(clearIndicators());
    setOpen(false);
  };

  return (
    <>
      <button className={`button ${styles.btn}`} onClick={() => setOpen(true)} title="Clear all">
        <TrashIcon className={styles.icon} />
        <span className={styles.count}>{total}</span>
      </button>

      <Modal isOpen={open} onClose={() => setOpen(false)} title="Clear all">
        <div className={styles.body}>
          <p className={styles.text}>
            Are you sure you want to remove all indicators and drawings from your trading interface?
          </p>
          <div className={styles.actions}>
            <button className={styles.cancelBtn} onClick={() => setOpen(false)}>Cancel</button>
            <button className={styles.okBtn} onClick={handleConfirm}>OK</button>
          </div>
        </div>
      </Modal>
    </>
  );
};
